<div class="bg-m0 flex select-none flex-col p-9">
  <div
    data-cy="editProjectNameDialogTitle"
    class="text-s2 mt-5 flex-grow text-left text-2xl font-semibold"
    >Edit Project Name</div
  >

  <form
    class="flex w-80 flex-col"
    [formGroup]="editProjectNameForm"
    (ngSubmit)="save()"
  >
    <input
      autocomplete="off"
      #projectName
      spellcheck="false"
      data-cy="editProjectNameDialogProjectNameInput"
      class="form-input border-s3 focus:border-m600 mt-9 rounded"
      [ngClass]="{
        'border-r600':
          editProjectNameForm.controls['projectName'].invalid &&
          editProjectNameForm.controls['projectName'].touched
      }"
      formControlName="projectName"
      placeholder="Name"
    />
    <m-validation
      [control]="editProjectNameForm.controls['projectName']"
    ></m-validation>

    <div class="mt-6">
      <button
        data-cy="editProjectNameDialogSaveButton"
        class="bg-m600 text-m0 w-28 rounded py-3 text-base font-medium focus:outline-none"
        type="submit"
        >Save</button
      >

      <button
        data-cy="editProjectNameDialogCancelButton"
        class="border-m600 text-m600 ml-3 w-28 rounded border py-3 text-base font-medium focus:outline-none"
        type="button"
        (click)="cancel()"
        >Cancel</button
      >
    </div>
  </form>
</div>
